export enum AttributeListSectionActionTypes {
  FETCH_ATTRIBUTES_FROM_IIKO_START_SAGA =  'FETCH_ATTRIBUTES_FROM_IIKO_STARTED_SAGA',
  START_LOADING =  'START_LOADING',
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
}



